import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { FinancialAnalysisPage } from '../pages/FinancialAnalysisPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/analysis/')({
  component: AnalysisRoute,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function AnalysisRoute() {
  return (
    <MainLayout>
      <FinancialAnalysisPage />
    </MainLayout>
  )
}
